module.exports = __webpack_public_path__ + "img/robot.9609663a.png";